<div class="w2-auction-title">
	<h2>{{{auctionTitle}}}</h2>
</div>
